import { render, staticRenderFns } from "./CustomerPopup.vue?vue&type=template&id=05bb0776&scoped=true"
import script from "./CustomerPopup.vue?vue&type=script&lang=js"
export * from "./CustomerPopup.vue?vue&type=script&lang=js"
import style0 from "./CustomerPopup.vue?vue&type=style&index=0&id=05bb0776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bb0776",
  null
  
)

export default component.exports